var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "app-radio-button",
      class: { "app-radio-button--disabled": _vm.$attrs.disabled }
    },
    [
      _c(
        "input",
        _vm._b(
          {
            staticClass: "app-radio-button__input",
            attrs: { type: "radio" },
            domProps: { checked: _vm.$attrs.value === _vm.modelValue },
            on: {
              change: function(event) {
                return _vm.$emit("change", event.target.value)
              }
            }
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _c("div", { staticClass: "app-radio-button__mark" }),
      _vm._v(" "),
      _c("div", { staticClass: "slot" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64fead4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64fead4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppRadioButton.vue
// module id = null
// module chunks = 